import { IFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { ICargoType } from './cargoesData'

export type IAsteroidType = 'error' | 'ice' | 'rock'

export interface IAsteroidData {
  idx: number
  type: IAsteroidType
  cargoType: ICargoType
  frame: IFrameInfo
}

const defaultData: IAsteroidData = {
  idx: -1,
  type: 'error',
  frame: frameInfo.fi32(5, 0, 0),
  cargoType: 'error',
}

export const dataList: IAsteroidData[] = []
export const dataMapIdx: { [key: number]: IAsteroidData } = {}
export const dataMapName: { [key: string]: IAsteroidData } = {}

export function addAsteroid(
  idx: number,
  type: IAsteroidType,
  data: Partial<IAsteroidData>,
) {
  let d = Object.assign({}, defaultData, data, {
    idx,
    type,
  })
  Object.freeze(d)
  dataList.push(d)
  dataMapIdx[idx] = d
  dataMapName['' + type] = d
}

export const createData = () => {
  addAsteroid(0, 'ice', { frame: frameInfo.fi32(5, 4, 9), cargoType: 'ice' })
  addAsteroid(1, 'rock', {
    frame: frameInfo.fi32(5, 4, 10),
    cargoType: 'steel',
  })
}
